import React from "react";
import '../../../assets/styles/_helpSection.scss'

const HelpSection = () => {
  return (
    <section className="help-section py-4 text-small-2">
      <div className="container text-center">
        <h6 className="mb-2 fw-bold">نیاز به کمک دارید؟</h6>
        <p className="mb-2">
          هر سوالی دارید، می‌توانید در هر زمان با ما تماس بگیرید.
        </p>


        <a href="tel:+9890009727" className="btn contact-btn px-4 text-small-1 fw-bold">
          90009727
        </a>
        <div className="divider"></div>
        <p className="mt-3 text-secondary ltr" style={{fontFamily: 'sans-serif, tahoma'}}><small>©2000-{new Date().getFullYear()} Home Style</small></p>
      </div>
    </section>


  );
};

export default HelpSection;
